import React, { useState } from "react";
import { Grid, Loader, Checkbox, Icon, Button } from "semantic-ui-react";
import moment from "moment";
import CustomPagination from "components/CustomPagination";
import DatePicker from "react-datepicker";
import FoldersList from "features/FoldersOverview/components/FoldersList";
const initialDate = moment().format("YYYY-MM-DD");

const ResearchFoldersList = ({ list, listTotalCount, refreshList, loading, pages, goToFolderManager }) => {
	const [filters, setFilters] = useState({
		centers: true,
		date: initialDate,
		showDone: false,
		page: 1,
	});

	const selectPatient = (folder) => {
		if (folder && folder.id) {
			goToFolderManager(folder.id);
		}
	};

	// Pagination
	const handlePageChange = async (page) => {
		let filtersCopy = { ...filters, page };
		setFilters(filtersCopy);
		await refreshList(filtersCopy);
	};
	const handleDateChange = (date) => {
		let filtersCopy = { ...filters, date: moment(date).format("YYYY-MM-DD"), page: 1 };
		setFilters(filtersCopy);
		refreshList(filtersCopy);
	};
	const handleDoneFolers = (showDone) => {
		let filtersCopy = { ...filters, showDone, page: 1 };
		setFilters(filtersCopy);
		refreshList(filtersCopy);
	};

	return (
		<div>
			<Grid style={{ margin: 0 }}>
				<Grid.Row style={{ backgroundColor: "#43b39e", padding: 10, borderRadius: "4px 4px 0 0" }}>
					<Grid.Column width={3} style={{ color: "#fff", fontWeight: 600, display: "flex", alignItems: "center" }}>
						<Icon name="folder" style={{ color: "#fff", fontSize: "1.5em" }} />
						{listTotalCount || 0} dossiers
					</Grid.Column>

					<Grid.Column width={8} style={{ display: "flex", alignItems: "center" }}>
						<Icon name="calendar alternate" style={{ color: "#fff", fontSize: "1.5em" }} />
						<DatePicker
							selected={new Date(filters.date)}
							onChange={(date) => handleDateChange(date)}
							className="datePicker"
							dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
						/>
					</Grid.Column>

					<Grid.Column width={5} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
						<Checkbox
							checked={filters.showDone}
							onChange={() => handleDoneFolers(!filters.showDone)}
							label={{ children: <span style={{ color: "#fff" }}>Dossiers terminés</span> }}
						/>
						<Button icon color="teal" size="tiny" onClick={() => refreshList(filters)}>
							<Icon name="refresh" />
						</Button>
					</Grid.Column>
				</Grid.Row>

				{/* Body */}
				{loading && <Loader active inline="centered" style={{ margin: 10 }} />}
				{!loading && list.length === 0 && <div style={{ textAlign: "center", margin: 10 }}>Aucun dossier</div>}
				{!loading && <FoldersList filters={filters} list={list} selectPatient={selectPatient} nurseApp={true} />}
			</Grid>

			{/* Pagination */}
			{pages > 1 && (
				<CustomPagination activePage={filters.page} totalPages={pages} onPageChange={(e, { activePage }) => handlePageChange(activePage)} />
			)}
		</div>
	);
};

export default ResearchFoldersList;
